import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigHelper } from './helpers/config.helper';
import { ProductDto, ResultWrapper, ShoppingSectionDto } from '../dtos/dto';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(
    private http: HttpClient,
    private configHelper: ConfigHelper
  ) { }


  getShoppingSections(): Observable<ResultWrapper<ShoppingSectionDto[]>> {
    return this.http.get<ResultWrapper<ShoppingSectionDto[]>>(this.configHelper.getApiUrl("ShoppingSections"));
  }

  getProductByTypeAndReg(typeId: number, regId: number): Observable<ResultWrapper<ProductDto[]>> {
    return this.http.get<ResultWrapper<ProductDto[]>>(this.configHelper.getApiUrl("products/") + typeId.toString() + "/" + regId.toString());
  }

  getProductByTypeId(productTypeId: number): Observable<ResultWrapper<ProductDto[]>> {
    return this.http.get<ResultWrapper<ProductDto[]>>(this.configHelper.getApiUrl("products/") + productTypeId.toString());
  }

  getProductInfo(productId: number): Observable<ResultWrapper<ProductDto>> {
    return this.http.get<ResultWrapper<ProductDto>>(this.configHelper.getApiUrl("product/") + productId.toString());
  }

  getHardCopyShippingProducts(regId: number): Observable<ResultWrapper<ProductDto[]>> {
    return this.http.get<ResultWrapper<ProductDto[]>>(this.configHelper.getApiUrl("hardcopyscorereportshippingproducts/") + regId.toString());
  }

  getBundleProductsForProduct(productId: number, currencyCode: string): Observable<ResultWrapper<ProductDto[]>> {
    return this.http.get<ResultWrapper<ProductDto[]>>(this.configHelper.getApiUrl("BundleProductsForProduct/" + productId + "/" + currencyCode));
  }

  downloadProductFile(productId: number): Observable<Blob> {
    return this.http.get(this.configHelper.getApiUrl(`User/Account/DownloadProductFile?productId=${productId}`), { responseType: 'blob' });
  }

  downloadProductPdf(productName: string): Observable<Blob> {
    return this.http.get(this.configHelper.getApiUrl("/User/Account/DownloadPDF" + '?filename=' + productName + ".pdf"), { responseType: 'blob' });
  }

  getInstructionalProductsUrl(productId: number) {
    return this.http.get<ResultWrapper<string>>(this.configHelper.getApiUrl("User/Account/GenerateIPLink" + "?productId=" + productId));
  }

  getInstructionalProductsUrlWithCode(code: string) {
    return this.http.get<ResultWrapper<string>>(this.configHelper.getApiUrl("User/Account/GenerateIPLinkWithCode" + "?code=" + code));
  }

  getEbookName(productId: number, userAccountProductId: number) {
    return this.http.get<ResultWrapper<string>>(this.configHelper.getApiUrl("User/Account/GetEbookFilename" + "?productId=" + productId + "&userAccountProductId=" + userAccountProductId));
  }

  getTopProducts(currencyCode: string, testTypeName: string): Observable<ResultWrapper<ProductDto[]>> {
    return this.http.get<ResultWrapper<ProductDto[]>>(this.configHelper.getApiUrl("topProducts?currencyCode=" + currencyCode + "&testType=" + testTypeName));
  }

}
